import {
  isEmptyText,
  Prismic,
  PrismicText,
  useInlineExpressions,
} from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React, { Fragment } from 'react';
import { PrismicTable } from '../components/table/PrismicTable';

interface IProps {
  bg: string;
  layout: string;
  zebra_color: string;
  text: Prismic.RichText;
  table: Prismic.RichText;
}

export const TableContainer = ({
  bg,
  layout,
  zebra_color,
  text,
  table,
}: IProps) => {
  const source = useInlineExpressions(Prismic.text(table) ?? '');
  if (isEmptyText(table)) {
    return null;
  }
  const themeColor = (type: string) => {
    switch (type) {
      case 'Gray':
        return 'primary';
      case 'White':
        return 'primary';
      case 'Blue':
        return 'ternary';
      case 'Orange':
        return 'secondary';
      default:
        'primary';
    }
  };

  const copy = !isEmptyText(text) ? <PrismicText value={text} /> : null;

  return (
    <Segment>
      <PrismicTable
        background={bg}
        layout={layout}
        theme={themeColor(zebra_color)}
        copy={copy}
      >
        <div dangerouslySetInnerHTML={{ __html: source ?? '' }} />
      </PrismicTable>
    </Segment>
  );
};
